import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { statusCodes,EwCommonService } from 'ew-common-lib';
import { EwMaTableListService } from '../../ew-ma-table-list.service';
import { TranslateService } from '@ngx-translate/core';
import { EwTranslateService } from '../../services/ew-translate.service';
import * as Highcharts from 'highcharts';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
//import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter, SatDatepickerModule } from 'saturn-datepicker-ext';

import { Sort } from '@angular/material/sort';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';



export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'MMM DD , YYYY',
    //dateInput: 'dddd, D MMMM, YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


//import { $ } from 'protractor';
//import worldMap from "@highcharts/map-collection/custom/world.geo.json";

@Component({
  selector: 'lib-ew-webinar-analytics',
  templateUrl: './webinar-analytics.component.html',
  styleUrls: ['./webinar-analytics.component.css'],
 // styles: ['.emoji-chat {max-width:30px} .mat-calendar-cell-semi-selected{background-color: #c5cae9;} .mat-calendar-body-begin-range:not(.mat-calendar-body-end-range) {border-radius: 100% 0 0 100%;background-color: #c5cae9;}  .mat-calendar-body-selected {background-color: #673ab7;color: #fff;}  .mat-calendar-body-end-range:not(.mat-calendar-body-begin-range) {border-radius: 0 100% 100% 0; background-color: #c5cae9;}.mat-calendar-body-cell-content {border-radius:999px !important;}'],
  styles: ['.emoji-chat {max-width:30px} ' ],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})


export class WebinarAnalyticsComponent implements OnInit {
  
  /**
   * @description
   * Event id from parent component.
   */
  //@Input() event_id: string = '518';
  //@Input() event_id: string = '2762';
 // @Input() event_id: string = '2769';
 // @Input() event_id: string = '2774';
 // @Input() event_id: string = '2779';
  // @Input() event_id: string = '3347'; for same offer multiple time
  @Input() event_id: string = '3206';
 // @Input() event_id: string = '2712';
  //@Input() event_id: string = '451';

  //@Input() event_id: string = '2194';
  //@Input() event_id: string = '161';

  //@Input() event_type: string = '';
  @Input() default_lang: string = 'en';

  @Input() isNotLiveEvent: boolean = true;

  @Input() userId:number = 7939;  

  public data = [];
  public offers = [];
  public polls = [];
  public chats = [];
  public questions = [];
  public page: number = 1;
  public offset: number = 0;
  public limit: number = 10;
  public chatOffset: number = 0;
  public chatLimit: number = 10;
  public searchChat: string = '';
  public totalItemsChat: number = 0;
  public totalRegistant: number = 0;
  public registerOffest: number = 0;
  public registerPage: number = 1;
  public search:string = '';
  public search_applied:boolean=false;


  public showSectionLoader: boolean = true;
  public showSectionLoaderForVisitorChart: boolean = true;
  public showSectionLoaderForRoomActivityChart: boolean = true;

  public showlistLoader: boolean = true;
  public showChatlistLoader: boolean = true;
  public showRegistLoader:boolean=false;

  public registerCount: number =0;
  public uniqueVistorCount: number =0;
  public attendeeCount: number =0;
  public watchedReplayCount: number =0;

  public selected_session: string ="option1";

  public selected_chart_option: string ="visitor";

  public offerIconForChart: string ="";
  public pollIconForChart: string ="";
  public offerIconForChartHeading: string ="";
  public pollIconForChartHeading: string ="";

  public bgRandom = [];

  public categoriesVistorMap = [];
  public vistorMapSeries = [];
  public registrantsMapSeries = [];
  public roomActivityMapSeries = [];
  public roomActivityMapXaxias = [];
  public roomActivityMapVideoMins = [];
  public roomActivityMapAttendeeMins = [];
  public sessions = [];
  public sessionsVideo = [];
  public finalMinsArrayForPoll = [];
  public dateRange:any;
  public startDate:any;
  public endDate:any;
  public pollsViewArray = [];
  public searchAttendee = new FormControl('');
  transLationMessages:any;   
  searchChatText = '';

  public bg = [
    'seablue', 'lighten-prple', 'greylight', 'lighten-red','purple-blue-light','tan-red','pink-light'
  ];

  //public options: any = {};

  public options: any = {
    chart: {
      type: 'line'
    },
    accessibility: {
        description: '',
    },
    title: {
        text: ''
    },
    subtitle: {
        text: ''
    },
    xAxis: {
      //categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      categories:[],
      labels: {
        // style:{
        //   color:"red"
        // },
        formatter: function () {
          // return this.value.split(" ")[0] + '';
           return this.value;
        }
      }
    },
    yAxis: {
        title: {
            text: ''
        },
        labels: {
          // style:{
          //   color:"red"
          // },
          formatter: function () {
              return this.value + '';
          }
        }
    },
    tooltip: {
        pointFormat: '{series.name} <b>{point.y:,.0f}'
    },
    plotOptions: {
        // series: {
        //     fillOpacity: 1
        // },
        area: {
            //pointStart: 1940,
            marker: {
                enabled: false,
                symbol: 'circle',
                radius: 2,
                states: {
                    hover: {
                        enabled: true
                    }
                }
            }
        }
    },
    series: [

    ],
    lang: { noData: "-------" },
  };

  public optionsRoomActivity: any ={
    chart: {
        type: 'area',
        //styledMode: true
    },
    accessibility: {
      description: '',
    },
    title: {
        text: ''
    },
    subtitle: {
        text: ''
    },
    xAxis: {
      //categories: ['0 min', '10 Mins', '20 Mins', '30 Mins', '40 Mins', '50 Mins', '60 Mins', '70 Mins', '80 Mins', '90 Mins', '100 Mins', '120 Mins'],
      categories: [],
    },
    yAxis: {
        title: {
            text: ''
        },
        labels: {
          formatter: function () {
              return this.value + '';
          }
        }
    },
    tooltip: {
        pointFormat: '{series.name}  <b>{point.y:,.0f}'
    },
    plotOptions: {
        area: {
            marker: {
                enabled: false,
                symbol: 'circle',
                radius: 2,
                states: {
                    hover: {
                        enabled: true
                    }
                }
            }
        }
    },
    series: [
    ]
  };


  public noRoomActivity = false;

  Highcharts: typeof Highcharts = Highcharts;
  updateGraph = false;
  range: any;
  form: FormGroup;
  public chatOrder = "desc";
  public images=[];
  public selected_session_id;
  emojiURL = 'https://ewpcdn-ecs.easywebinar.com/livechat/components/EmojiPicker/emojis/';
  public model:object = {};
  public searchAttendeeText = false;
  constructor(
    private tableListService: EwMaTableListService,
    private ewTranslateService: EwTranslateService,
    public translate: TranslateService,
    public ewCommonService: EwCommonService,
    public fb: FormBuilder,
  ) {
    // this.form = fb.group({
    //   date: [{end: moment.utc().format('YYYY-MM-DD'), begin: moment().utc().subtract(30, "days").format('YYYY-MM-DD')}]
    // });
   } //YYYY-MM-DD

  ngOnInit(): void {
    this.translate.setDefaultLang(this.default_lang);
    this.translate.use(this.default_lang).subscribe(() => {
      this.ewTranslateService.init();
    });

    this.pollIconForChart="url("+this.tableListService.getV2CDN()+"assets/images/chart_icons/poll_icon.png)";
    this.offerIconForChart="url("+this.tableListService.getV2CDN()+"assets/images/chart_icons/offer_icon.png)";
    this.pollIconForChartHeading="url("+this.tableListService.getV2CDN()+"assets/images/chart_icons/bar_chart-24px.png)";
    this.offerIconForChartHeading="url("+this.tableListService.getV2CDN()+"assets/images/chart_icons/campaign-24px.png)";
    this.images['no-Visito-summary'] = this.V2CDN()+"assets/images/no-Visito-summary.png";
    this.images['no-event-activity'] = this.V2CDN()+"assets/images/no-event-activity.png";

    if(sessionStorage.getItem('startDate_'+this.event_id) && sessionStorage.getItem('endDate_'+this.event_id)){
      this.startDate = sessionStorage.getItem('startDate_'+this.event_id);
      this.endDate = sessionStorage.getItem('endDate_'+this.event_id);
   }else{
    this.endDate = moment.utc().format('YYYY-MM-DD');
    this.startDate = moment().utc().subtract(30, "days").format('YYYY-MM-DD');
   }
   
    this.form = this.fb.group({
      date: [{end: this.endDate, begin:this.startDate}]
    });

    this.transLationMessages = this.translate.store.translations[this.default_lang];
    //Random Classes for Attendee Image
    this.bgRandom = [];
    for (let i =0; i < this.chatLimit; i++) {
      let randomNumber = Math.floor(Math.random() * this.bg.length);
      this.bgRandom.push(this.bg[randomNumber]);
    }
    this.getWebinarStats();    
    this.getCTAStats();
    this.getChatHistory();
    this.getVisitorChartData();


    //this.getRoomActivityData();
   this.tableListService.getWebinarDetails({'id': this.event_id}).subscribe(
    (response: any) => {

      if (response.status.code == statusCodes.SUCCESS) {
        this.getSessionList();
        if(response.data.is_livestream==="1"){
          this.isNotLiveEvent=false;
         // this.getSessionList();
          this.images['no-registrants'] = this.V2CDN()+"assets/images/no-registrants-icon-default.svg";
          this.images['no-cta-stats'] = this.V2CDN()+"assets/images/no-cta-stats-default.svg";
          this.images['no-question-icon'] = this.V2CDN()+"assets/images/no-messages-found-default.svg";
          this.images['no-search'] = this.tableListService.getV2CDN()+'assets/images/no-data-found-default.svg'


        }else{
          this.isNotLiveEvent=true;
         // this.getSessionVideoList();
          if(response.data.is_livestream == "2"){ //evergreen

            this.images['no-registrants'] = this.V2CDN()+"assets/images/no-registrants-icon-evergreen.svg";
            this.images['no-cta-stats'] = this.V2CDN()+"assets/images/no-cta-stats-evergreen.svg";
            this.images['no-question-icon'] = this.V2CDN()+"assets/images/no-question-icon-evergreen.svg";
            this.images['no-search'] = this.tableListService.getV2CDN()+'assets/images/no-data-found-evergreen.svg'

          }else{ // simulated
            this.images['no-registrants'] = this.V2CDN()+"assets/images/no-registrants-icon-simulated.svg";
            this.images['no-cta-stats'] = this.V2CDN()+"assets/images/no-cta-stats-simulated.svg";
            this.images['no-question-icon'] = this.V2CDN()+"assets/images/no-question-icon-simulated.svg";
            this.images['no-search'] = this.tableListService.getV2CDN()+'assets/images/no-data-found-simulated.svg'

          }
        }
        //console.log("}}}}}}}",this.images);

      } else {
        console.log('getWebinarDetails Error in api request', response);

      }

    },
    (error) => {

      console.log('getWebinarDetails error', error);

    }
  );

  //   this.range = new FormGroup({
  //     start: new FormControl(),
  //     end: new FormControl()
  //  });

 
   this.searchAttendee.valueChanges.pipe(debounceTime(800), distinctUntilChanged()).subscribe((searchTerm: string) => { 
    this.registerOffest = 0;
    this.searchAttendees();
  });


  }



  getShortName(fullName) {
    let shortName=fullName.split(' ').map(n => n[0]).join('');
    return shortName.toUpperCase();
  }

  eventType(type) {
    let returnValue="Automated";
    if(type == "2"){
      returnValue="Automated Gold";
    }else if(type == "1"){
      returnValue="Live";
    }
    return returnValue;
  }

  changeChartType(chartType) {
   this.selected_chart_option=chartType;
  }

  getPercentage(value:number, total:number) {
    if(total >= value){
      const percent = (value / total) * 100;
      if(Number.isNaN(percent)){
        return "0%";
      }
      return percent.toFixed(2) + "%";
    }else{
      return "-";
    }

  }

  /**
   * @description
   * Get webinars Stats
   */
  getVisitorChartData() {
    let registrantsDataLoad = false, visistorDataLoad= false;

    const modelVisitor={
      "query" : {
        "index" : "visitors",
        "body": {
          "from" :0,
          "size": 2,
          "query" : {
            "bool" :{
              "must" : [
                {
                  "match" : {
                    "webinar_id" :this.event_id
                  }
                },
                {
                  "range": {
                    "visit_time": {
                      "gte":this.startDate+' 00:00:00',
                      "lte":this.endDate+' 23:59:59',
                    }
                  }
              }
              ]
            }
          },
          "aggs": {
            "range": {
              "date_histogram": {
                "field": "visit_time",
                "calendar_interval": "1d"
              }
            }
          }
        }
      }
    };
    this.tableListService.getAttendees(modelVisitor).subscribe(
      (response: any) => {
        if (response.statusCode == statusCodes.SUCCESS) { 
          this.categoriesVistorMap = [];
          this.vistorMapSeries = [];
          let resData = response.body.aggregations.range.buckets;

          resData.forEach( (element,index) => {
            //this.categoriesVistorMap.push(element.key_as_string);
            this.categoriesVistorMap.push(element.key_as_string.split(" ")[0]);
            this.vistorMapSeries.push(element.doc_count);
          });
          visistorDataLoad=true;
        } else {
          console.log('Error in api request-----');
        }
      },
      (error) => {
        console.log('error', error);

      }
    );

    const modelRegistrants={​​​
      "query" : {​​​
        "index" : "attendees",
        "body": {​​​
          "from" :0,
          "size": 2,
          "query" : {​​​
            "bool" :{​​​
              "must" : [
                {​​​
                  "match" : {​​​
                    "owner_id" :this.userId
                  }​​​
                }​​​,
                {​​​
                  "match" : {​​​
                    "webinar_id":this.event_id
                  }​​​
                }​​​,
                {
                  "range": {
                    "session_date": {
                      "gte":this.startDate+' 00:00:00',
                      "lte":this.endDate+' 23:59:59',
                    }
                  }
              }
              ]

            }​​​

          }​​​,
          "aggs": {​​​
            "range": {​​​
            "date_histogram": {​​​
              "field": "signup",
              "calendar_interval": "1d"
              }​​​
            }​​​
          }​​​
        }​​​
      }​​​
    }​​​;

  
    this.showSectionLoaderForVisitorChart = true;
    this.tableListService.getAttendees(modelRegistrants).subscribe(
      (response: any) => {
        this.showSectionLoaderForVisitorChart = false; 
        if (response.statusCode == statusCodes.SUCCESS) {
          this.categoriesVistorMap = [];
          this.registrantsMapSeries = [];
          this.options["series"] = [];
          let resData = response.body.aggregations.range.buckets;
          resData.forEach( (element,index) => { 
           // this.categoriesVistorMap.push(element.key_as_string);
            this.categoriesVistorMap.push(element.key_as_string.split(" ")[0]);
            this.registrantsMapSeries.push(element.doc_count);
          });
          registrantsDataLoad=true;
          if(this.categoriesVistorMap.length == 0){
            this.categoriesVistorMap = ['0 '];
          }
          if(this.registrantsMapSeries.length == 0){
            this.registrantsMapSeries = [0];
          }
       
          let visitorSeriesData={
              name: this.transLationMessages.WEBINAR_ANALYTICS.VISITORS,
              className:"visitors-wrapper",
              data: this.vistorMapSeries,
              color: '#178EFC',
              borderColor: 'red',

          };
          let registrantsSeriesData={
              name: this.transLationMessages.WEBINAR_ANALYTICS.REGISTRANTS,
              className:"registrants-wrapper",
              data: this.registrantsMapSeries,
              color: '#784BD1'
          };
         this.options["xAxis"]["categories"]=this.categoriesVistorMap;
         this.options["series"].push(visitorSeriesData);
         this.options["series"].push(registrantsSeriesData);
        } else {
          let visitorSeriesData={
            name: this.transLationMessages.WEBINAR_ANALYTICS.VISITORS,
            className:"visitors-wrapper",
            data: [0],
            color: '#178EFC',
            borderColor: 'red',

        };
        let registrantsSeriesData={
            name: this.transLationMessages.WEBINAR_ANALYTICS.REGISTRANTS,
            className:"registrants-wrapper",
            data: [0],
            color: '#784BD1'
        };
        
       // this.options.lang.noData = 'No data to display';
        this.options["xAxis"]["categories"]=[0];
        this.options["series"].push(visitorSeriesData);
        this.options["series"].push(registrantsSeriesData);
        }

      },
      (error) => {
        this.showSectionLoaderForVisitorChart = false;
        console.log('error', error);
      }
    );

  }

  getChatHistory() {
    const model = {
      "offset" : this.chatOffset,
      "limit" :this.chatLimit,
      "webinar_id":this.event_id,
      "search":this.searchChat,
      startDate:this.startDate,
      endDate:this.endDate,
      orderBy:this.chatOrder
    };
    this.showChatlistLoader = true;
    this.tableListService.getQuestions(model).subscribe(
      (response: any) => {
        this.showChatlistLoader = false;
        if (response.status.code == statusCodes.SUCCESS) {
          this.totalItemsChat = response.data.total; 
          this.searchChatText = this.searchChat == ''?'':'1';
          //this.chats= response.data?.chat;
          //console.log((this.isNotLiveEvent)); //alert(this.isNotLiveEvent);
          if(this.isNotLiveEvent === true){
            let questions =  response.data?.questions;
            if(this.questions.length>0 && this.chatOffset != 0){
            let newArr = this.questions.concat(questions);
            this.questions = newArr;
            }else{
              this.questions = questions;
            }
          }else{

            let chats = response.data?.chat;
            if(this.chats.length>0 && this.chatOffset != 0){
            let newArr = this.chats.concat(chats);
            this.chats = newArr;
            }else{
              this.chats = chats;
            }
          }

        } else {
          console.log('Error in api request');
          this.showChatlistLoader = false;
        }

      },
      (error) => {
        this.showChatlistLoader = false;
        console.log('error', error);

      }
    );
  }

  /**
   * @description
   * Get webinars Stats
   */
  getCTAStats() {
    const model = {
      "query" : {
        "index" : "offer_tracking",
        "body": {
          "from" :this.offset,
          "size": "100",
          "query" : {​​​
            "bool" :{​​​
              "must" : [
                {​​​
                  "match" : {​​​
                    "webinar_id" :this.event_id
                  }​​​
                }​​​,{
                  "range": {
                    "offer_tracked_at": {
                      "gte":this.startDate+' 00:00:00',
                      "lte":this.endDate+' 23:59:59',
                    }
                  }
              }
              ]

            }​​​

          }​​​,
          "aggs": {​​​
            "offers": {​​​
              "terms": {​​​
                "field": "offer_desc.offer_title"
                }​​​,
              "aggs" : {​​​
                "views" :{​​​
                  "filter" : {​​​
                  "term" :{​​​
                      "offer_action" : 1
                    }​​​
                  }​​​
                }​​​,
                "clicks" : {​​​
                  "filter" : {​​​
                    "term" :{​​​
                      "offer_action" : 2
                    }​​​
                  }​​​
                }​​​,
                "purchases" : {​​​
                  "filter" : {​​​
                    "term" :{​​​
                      "offer_action" : 3
                    }​​​
                  }​​​
                }​​​,
                "revenue":{​​​
                  "sum" : {​​​
                    "field" : "offer_sale"
                  }​​​
                }​​​
              }​​​
            }​​​
          }​​​
        }
      },
    };
    this.showlistLoader = true;
    this.tableListService.getAttendees(model).subscribe(
      (response: any) => {
        this.showlistLoader = false;
        if (response.statusCode == statusCodes.SUCCESS) {
          this.offers= response.body.aggregations.offers.buckets;
          //console.log("offers list",this.offers);
        } else {
          console.log('Error in api request');
          this.showlistLoader = false;
        }

      },
      (error) => {
        this.showlistLoader = false;
        console.log('error', error);

      }
    );


    const pollModel = {
      "query" : {
        "index" : "poll_tracking",
        "body": {
          "from" :0,
          "size": "100",
          "query" : {​​​
            "bool" :{​​​
              "must" : [
                {​​​
                  "match" : {​​​
                    "webinar_id" :this.event_id
                  }​​​
                }​​​,
                {
                  "range": {
                    "poll_tracked_at": {
                      "gte":this.startDate+' 00:00:00',
                      "lte":this.endDate+' 23:59:59',
                    }
                  }
              }
              ]

            }​​​

          }​​​,
          "aggs": {​​​
            "polls": {​​​
              "terms": {​​​
                "field": "poll_desc.poll_question"
              }​​​,
              "aggs" : {​​​
                "views" :{​​​
                  "filter" : {​​​
                    "term" :{​​​
                      "poll_action" : 1
                    }​​​
                  }​​​
                }​​​,
                "clicks" : {​​​
                  "filter" : {​​​
                    "term" :{​​​
                    "poll_action" : 2
                    }​​​
                  }​​​
                }​​​
              }​​​
            }​​​
          ​​​}
        }
      },
    };

    this.tableListService.getAttendees(pollModel).subscribe(
      (response: any) => {
        if (response.statusCode == statusCodes.SUCCESS) {
          this.polls= response.body.aggregations.polls.buckets;
        } else {
          console.log('Error in api request');
        }

      },
      (error) => {
        console.log('error', error);

      }
    );
  }

  /**
   * @description
   * Get webinars Stats
   */
   getWebinarStats() {
    this.showRegistLoader = true;
    this.model={
      "query" : {
        "index" : "attendees",
        "body": {
          "from" :this.registerOffest,
          "size": this.limit,
          "query" : {
            "bool" :{
              "must" : [
                {
                "match" : {
                  "webinar_id" :this.event_id
                }
              },
              {
                "range": {
                  "session_date": {
                    "gte":this.startDate+' 00:00:00',
                    "lte":this.endDate+' 23:59:59',
                    // "format": "YYYY-MM-DD"
                  }
                }
              }
            ,{
              "query_string": {
                "query": "**",
                "fields": [ "attendee_name", "attendee_email" ],
              }
            }
              ]
            }
          },
          "sort" : {
            "signup" :{
              "order" : "desc"
            }
          },
          "aggs": {
            "registrants": {
              "filter" : {
              "term" :{
                "webinar_id" :this.event_id
              }
              },
              "aggs" : {
                "attendees" :{
                  "filter" : {
                    "term" :{
                    "event_activity" : 1
                    }
                  }
                },
                "replay_attendees" :{
                  "filter" : {
                  "term" :{
                  "replay_activity" : 1
                  }
                  }
                }
              }
            }
          }
        }
      }
    };
    this.showSectionLoader = true;
    this.tableListService.getAttendees(this.model).subscribe(
      (response: any) => {
        this.showSectionLoader = false;
        this.showRegistLoader = false;
        if (response.statusCode == statusCodes.SUCCESS) {
          this.data = response.body.hits;
          this.registerCount = response.body.aggregations.registrants.doc_count;
          this.attendeeCount = response.body.aggregations.registrants.attendees.doc_count;
          this.watchedReplayCount = response.body.aggregations.registrants.replay_attendees.doc_count;
        } else {
          console.log('Error in api request');
          this.showSectionLoader = false;
        }

      },
      (error) => {
        this.showSectionLoader = false;
        console.log('error', error);

      }
    );


    const uniqueVistiorCountModal = {
      "user_id": this.userId,
      "query": {
        "index": "visitors",
        "body": {
          "from": this.offset,
          "size": this.limit,
          "query": {
            "bool": {
              "must": [
                {
                  "match": {
                    "webinar_id": this.event_id
                  }
                },
                {
                    "range": {
                      "visit_time": {
                        "gte":this.startDate+' 00:00:00',
                        "lte":this.endDate+' 23:59:59',
                        // "format": "YYYY-MM-DD"
                      }
                    }
                }
              ]
            }

          }
        }
      },
    };
    this.tableListService.getAttendees(uniqueVistiorCountModal).subscribe(
      (response: any) => {
        if (response.statusCode == statusCodes.SUCCESS) {
          this.uniqueVistorCount = response.body.total.value;
        } else {
          console.log('Error in api request=');
        }
      },
      (error) => {
        console.log('error', error);

      }
    );

  }

    /**
   * @description
   * Get webinars Stats
   */
     searchAttendees() { 

      this.showRegistLoader = true;
      let model={
        "query" : {
          "index" : "attendees",
          "body": {
            "from" :this.registerOffest,
            "size": this.limit,
            "query" : {
              "bool" :{
                "must" : [
                  {
                  "match" : {
                    "webinar_id" :this.event_id
                  }
                },{
                  "bool":{
                    "should":[
                        {
                        "multi_match" : {
                          "query":      this.searchAttendee.value ,
                         // "type":       "bool_prefix",
                          "fields":     ["attendee_name", "attendee_email"],
                        }
                      }
                      ,{
                        "query_string" : {
                          "query" :  "*"+this.searchAttendee.value+"*",
                          "fields" : ["attendee_name", "attendee_email"],
                          "allow_leading_wildcard": true,
                          
                      }
                      }                     
                    ]                  
                }
              }
                ]
              },
            },
            "sort" : {
              "signup" :{
                "order" : "desc"
              }
            },
            "aggs": {
              "registrants": {
                "filter" : {
                "term" :{
                  "webinar_id" :this.event_id
                }
                },
                "aggs" : {
                  "attendees" :{
                    "filter" : {
                      "term" :{
                      "event_activity" : 1
                      }
                    }
                  },
                  "replay_attendees" :{
                    "filter" : {
                    "term" :{
                    "replay_activity" : 1
                    }
                    }
                  }
                }
              }
            }
          }
        }
      };


     if(this.searchAttendee.value == ''){ //remove multi_match query
      model["query"]["body"]["query"]["bool"]["must"].splice(2,1);
    
     }
          
      this.tableListService.getAttendees(model).subscribe(
        (response: any) => {
         
          this.showSectionLoader = false;
          this.showRegistLoader = false;
          this.searchAttendeeText = true;
          if (response.statusCode == statusCodes.SUCCESS) {
            this.data = response.body.hits;
            this.registerCount = response.body.aggregations.registrants.doc_count;
          } else {
            console.log('Error in api request');
            this.showSectionLoader = false;
          }

        },
        (error) => {
          this.showSectionLoader = false;
          console.log('error', error);

        }
      );

    }



  /**
   * @description
   */
  getRoomActivityData(){ 
    
    let model={
      "query" : {
        "index" : "attendee_presence", //attendees
        "body": {
          "from" :0,
          "size": 1,
          "query" : {
            "bool" :{
              "must" : [
              ]

            }

          },
          "aggs" :{
          }
        }
      }
    };
    
        let mainConditions={
          "match" : {
            "webinar_id" : this.event_id
          }
        };
      /*  
        let mainConditions2={
          "match" : {
            "event_activity" : 1
          }
        };
          let filterCondition = {
            "range":
          {
            "session_date" : {
              "gte":this.startDate+' 00:00:00',
              "lte":this.endDate+' 23:59:59',
            }
          }
        };
        */

    model["query"]["body"]["query"]["bool"]["must"].push(mainConditions);
   // model["query"]["body"]["query"]["bool"]["must"].push(mainConditions2);
   // model["query"]["body"]["query"]["bool"]["must"].push(filterCondition);

    //Automated Event
  //  if(this.isNotLiveEvent == true){
      let filterQuery={
        "match" : {
          "global_session_id" :this.selected_session_id
        }
      };
      model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
   /*  }else{
      let filterQuery={
        "match" : {
          "live_session_id": this.selected_session_id
        }
      };
      model["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
    }
    
      let AggsQuery={
        "event_activity": {
          "terms": {
            "field": "event_joined_after_minutes",
            "size" : 1000
          }
        }
      };
      */
    let AggsQuery={
      "event_activity": {
        "terms": {
          "field": "present_at_minutes",
          "size":1000,
          "order": {"_term": "asc"}
          }
      }
    };
    model["query"]["body"]["aggs"]=AggsQuery;
    this.showSectionLoaderForRoomActivityChart=true;
    this.roomActivityMapVideoMins = [];
    this.roomActivityMapAttendeeMins = [];
    this.roomActivityMapSeries = [];

    this.tableListService.getAttendees(model).subscribe(
      (response: any) => { 
        //this.showSectionLoaderForRoomActivityChart=false;
        if (response.statusCode == statusCodes.SUCCESS) { 
          let resData = response.body.aggregations.event_activity.buckets;
          resData.forEach( (element,index) => {
            // Main array of Mins for X Axias
            this.roomActivityMapVideoMins.push(element.key);
            // Attendee Data based Mins
            this.roomActivityMapAttendeeMins.push(element.key);

            // let xaxiasformat=(element.key > 0) ? element.key+" mins":element.key+" min";
            // this.roomActivityMapXaxias.push(xaxiasformat);
            this.roomActivityMapSeries.push(element.doc_count);
          });

          this.getPollsForRoomActivity();

        } else { 
          this.showSectionLoaderForRoomActivityChart=false;
          console.log('Error in api request');



          let seriesOfferData={
            name: this.transLationMessages.WEBINAR_ANALYTICS.OFFER_SENT,
            className:"room-activity-offer-wrapper",
            data: [0,0],
           // enableMouseHover: false,
            type: 'scatter',
            marker: {
              symbol: this.offerIconForChart,
            },
            tooltip: {
              enabled: false,
              stickyTracking: false,          
            }, 

        };

        let seriesPollData={
            name: this.transLationMessages.WEBINAR_ANALYTICS.POLL_SENT,
            className:"room-activity-poll-wrapper",
            data: [0,0],
            type: 'scatter',
            marker: {
              symbol: this.pollIconForChart,
            },
            tooltip: {
              enabled: false,
              stickyTracking: false,          
            }
        };
        

        let seriesData={
            name: this.transLationMessages.WEBINAR_ANALYTICS.ATTENDEES,
            className:"room-activity-attendees-wrapper",
            data: [0,0],
            tooltip: {
              pointFormat: this.transLationMessages.WEBINAR_ANALYTICS.ATTENDEES+'<b>{point.y:,.0f}',
              enabled: true
            },
            //data: [2,4,5,4,5,4,5,4,5,4,5,4,5,4],
            color: '#81ccfd',
        };


        this.showSectionLoaderForRoomActivityChart=false;

        this.optionsRoomActivity["xAxis"]["categories"]=[0,1.2];
        this.optionsRoomActivity["series"].push(seriesData);
        this.optionsRoomActivity["series"].push(seriesOfferData);
        this.optionsRoomActivity["series"].push(seriesPollData);
        // let y = new Highcharts.Chart(this.optionsRoomActivity);
        // this.optionsRoomActivity.update();
         //y.redraw();
         this.updateGraph = true;
        try {
          
          let emptyCount = 0;
          if(Array.isArray(seriesData.data) && seriesData.data[0] <= 0){
            emptyCount++;
          }
          if(Array.isArray(seriesOfferData.data) && seriesOfferData.data[0]['y'] <= 0){
            emptyCount++;
          }
          if(Array.isArray(seriesPollData.data) && seriesPollData.data[0]['y'] <= 0){
            emptyCount++;
          }
          if(emptyCount === 3){
            this.noRoomActivity = true;
          }
        } catch (error) {
          console.log("error in room activity chart empty check", error)
        }

        }

      },
      (error) => {
        this.showSectionLoaderForRoomActivityChart=false;
        console.log('error', error);

      }
    );

  }




  getOfferForRoomActivity(){  
    let offerModel={
      "query" : {
        "index" : "offer_tracking",
        "body": {
          "from" :0,
          "size": 1,
          "query" : {
            "bool" :{
              "must" : [
              ]
            }
          },
          "aggs" :{
            "offer_activity": {
              "terms": {
                "field": "offer_desc.offer_title",
                "size" : 1000
              },
              "aggs" : {
                  "offer_displayed_after_minutes" :{
                  "terms" :{
                    "field" : "offer_displayed_after_minutes"
                  }
                }
              }
            },
            "offers": {​​​
              "terms": {​​​
                "field": "offer_desc.offer_title"
                //"field": "offer_id"
                }​​​,
              "aggs" : {​​​
                "views" :{​​​
                  "filter" : {​​​
                  "term" :{​​​
                      "offer_action" : 1
                    }​​​
                  }​​​
                }​​​,
                "clicks" : {​​​
                  "filter" : {​​​
                    "term" :{​​​
                      "offer_action" : 2
                    }​​​
                  }​​​
                }​​​,
                "purchases" : {​​​
                  "filter" : {​​​
                    "term" :{​​​
                      "offer_action" : 3
                    }​​​
                  }​​​
                }​​​,
                "revenue":{​​​
                  "sum" : {​​​
                    "field" : "offer_sale"
                  }​​​
                }​​​
              }​​​
            }​​​
          }
        }
      }
    };

    let mainConditionsOffer={
      "match" : {
        "webinar_id" : this.event_id
      }
    };
    let mainConditionsOffer2={
      "match" : {
        "is_from_replay" : 0
      }
    };

    offerModel["query"]["body"]["query"]["bool"]["must"].push(mainConditionsOffer);
    offerModel["query"]["body"]["query"]["bool"]["must"].push(mainConditionsOffer2);

    //Automated Event
   /* if(this.isNotLiveEvent == true){
      let filterQuery={
        "match" : {
          "event_version_id" :this.selected_session
        }
      };
      offerModel["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
    }else{
      let filterQuery={
        "match" : {
          //"session_date": this.selected_session
          "session_id":this.selected_session_id
        }
      };
      offerModel["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
    }*/

    let filterQuery={
      "match" : {
        "session_id":this.selected_session_id
      }
    };
    offerModel["query"]["body"]["query"]["bool"]["must"].push(filterQuery);

    this.optionsRoomActivity["xAxis"]["categories"] = '';
    this.optionsRoomActivity["series"] = [];
    
    this.tableListService.getAttendees(offerModel).subscribe( 
      (response: any) => { console.log("response",response);
        let totalAttenddes = this.attendeeCount;
        if (response.statusCode == statusCodes.SUCCESS) { 
          let finalMinsArrayForOffer=[];
          let offer_activity = response.body.aggregations.offer_activity.buckets;
          let offer_views = response.body.aggregations.offers.buckets;
          let offerMinsArray=[];
          let actionArray=[];
          offer_activity.forEach( (element,index) => {
            offerMinsArray.push(element.offer_displayed_after_minutes.buckets);
          });
          offer_views.forEach( (element,index) => {
            let actions = {'offer_title':element.key,"views":element.views.doc_count,"clicks":element.clicks.doc_count,"revenue":element.revenue.value,"purchases":element.purchases.doc_count};
            actionArray.push(actions);
          });
          if(offerMinsArray.length){
            offerMinsArray.forEach( (element,index) => {
              finalMinsArrayForOffer.push(element[0].key);
              this.roomActivityMapVideoMins.push(element[0].key);
            });

          }
          this.roomActivityMapVideoMins = this.roomActivityMapVideoMins.sort(function(a, b) {
            return a - b;
          });

          this.roomActivityMapVideoMins= this.roomActivityMapVideoMins.filter(this.onlyUnique);
          let attendeeMinsIndex=[];
          let offerShownMinsIndex=[];
          let pollShownMinsIndex=[];

          let attendeeSericeData=[];
          let offerSericeData=[];
          let pollSericeData=[];
          let finalOffersViews=[];
          let finalPollsViews=[];

          const emptyOffer={
              y: 0,
              marker: {
                width: 0,
                height: 0
              },
          };

         this.roomActivityMapXaxias = [];
          this.roomActivityMapVideoMins.forEach((videoMins,index) => { //console.log("@@@@"+videoMins);
            offerSericeData.push(emptyOffer);
            pollSericeData.push(emptyOffer);

            if(this.roomActivityMapSeries[0] > 0){
              attendeeSericeData.push(this.roomActivityMapSeries[0]);
              
            }else{
              attendeeSericeData.push(0);
            }


            let xaxiasformat=(videoMins > 1) ? videoMins+" mins":videoMins+" min";
            this.roomActivityMapXaxias.push(xaxiasformat); 
            this.roomActivityMapAttendeeMins.forEach((attendeeMins) => {
              if(videoMins == attendeeMins){
                attendeeMinsIndex.push(index);
              }
            });

            finalMinsArrayForOffer.forEach((offerMins,offerIndex) => { //console.log("videoindex="+videoMins+" index"+index+"  offerMins"+offerMins);
              if(videoMins == offerMins){
                offerShownMinsIndex.push(index);
                finalOffersViews.push(actionArray[offerIndex]);
              }
            });

            this.finalMinsArrayForPoll.forEach((pollMins,pollsIndex) => {
              if(videoMins == pollMins){
                pollShownMinsIndex.push(index);
                finalPollsViews.push(this.pollsViewArray[pollsIndex]);
              }
            });

          });

let tooltipEnabled = true;
let tooltipEnabledPolls = true;
let offerImage = this.tableListService.getV2CDN()+"assets/images/chart_icons/offer_icon.png";
let pollImage = this.tableListService.getV2CDN()+"assets/images/chart_icons/poll_icon.png";
let attendeesCaption = this.transLationMessages.WEBINAR_ANALYTICS.ATTENDEES;
let viewsCaption = this.transLationMessages.WEBINAR_ANALYTICS.VIEWS;
let clicksCaption = this.transLationMessages.WEBINAR_ANALYTICS.CLICKS;
let revenueCaption = this.transLationMessages.WEBINAR_ANALYTICS.REVENUE;
let responseCaption = this.transLationMessages.WEBINAR_ANALYTICS.RESPONSES;
//console.log("offer",offerShownMinsIndex,attendeeSericeData);
          offerShownMinsIndex.forEach((videoMinsIndex,action_index) => { 
            offerSericeData[videoMinsIndex]={ 
                 y:attendeeSericeData[action_index], //0.1,
              //  y: 0.1+(finalOffersViews[action_index].views+finalOffersViews[action_index].clicks),
             dataLabels: { enabled: false },
                marker: {
                    symbol: this.offerIconForChart,
                    width: 20,
                    height: 20
                },
                events: {
                  click: function() {
                    this.series.chart.update({
                      tooltip: {
                        headerFormat: '',
                        enabled: tooltipEnabled,
                        useHTML:true,
                        name:false,
                        backgroundColor: '#2B2B30',
                        borderWidth: 0,
                        borderRadius:20,
                      pointFormat:'<div>'+
                      '<div  style="background: #2B2B30; box-shadow: 0px 4px 48px rgba(43, 43, 48, 0.08); border-radius: 8px; display: inline-flex; flex-wrap: wrap; width: 100%;"><div style="padding: 12px 19px 8px; border-bottom: 2px solid rgba(255, 255, 255, 0.1); width: 100%;">'+
                      '<span style="color: white; font-size: 14px; line-height: 16px; white-space: pre-wrap; word-break: break-word;">'+finalOffersViews[action_index].offer_title+'</span>'+
                      '</div>'+
                      '<div style="padding: 14px 19px 32px; display: flex; width: 100%; position: relative;">'+
                      '<div style="margin-right: 30px; display: inline-flex; flex-wrap: wrap;"><span style="color: white; width: 100%;font-size: 21px;">'+totalAttenddes+'</span><span style="color: white; font-weight: 400; font-size: 14px;">'+attendeesCaption+'</span></div>'+
                      '<div style="margin-right: 30px; display: inline-flex; flex-wrap: wrap;"><span style="color: white; width: 100%;font-size: 21px;">'+finalOffersViews[action_index].views+'</span><span style="color: white; font-weight: 400; font-size: 14px;">'+viewsCaption+'</span></div>'+
                      '<div style="margin-right: 30px; display: inline-flex; flex-wrap: wrap;"><span style="color: white; width: 100%;font-size: 21px;">'+finalOffersViews[action_index].clicks+'</span><span style="color: white; font-weight: 400; font-size: 14px;">'+clicksCaption+'</span></div>'+
                      '<div style="margin-right: 30px; display: inline-flex; flex-wrap: wrap;"><span style="color: white; width: 100%;font-size: 21px;">'+finalOffersViews[action_index].revenue+'</span><span style="color: white; font-weight: 400; font-size: 14px;">'+revenueCaption+'</span></div>'+
                      '<img style="position: absolute; bottom: 9px; right: 11px;" src="'+offerImage+'" alt="offers">'+
                      '</div></div></div>'

                      }
                    });
                    tooltipEnabled = tooltipEnabled ? false : true;
                  },
                  mouseOver: function () {
                    var chart = this.series.chart;
                    chart.update({
                      tooltip: {
                        enabled: false,
                      }
                    })

                  },
                  mouseOut: function () {
                  var chart = this.series.chart;
                  tooltipEnabled = true;
                  chart.update({
                    tooltip: {
                      enabled: false,
                    }
                  })
                }
                }
            };

          });

          pollShownMinsIndex.forEach((videoMinsIndex,polls_action_index) => {
            pollSericeData[videoMinsIndex]={
               y:attendeeSericeData[polls_action_index],
               //y: (finalPollsViews[polls_action_index].views+finalPollsViews[polls_action_index].clicks), //0.2
                dataLabels: {
                    className: 'ew-room-activity-poll-icon'
                },
                marker: {
                    symbol: this.pollIconForChart,
                    width: 20,
                    height: 20
                },
                events: {
                  click: function() {
                    //let action_index = videoMinsIndex>0?videoMinsIndex-1:0;
                    this.series.chart.update({
                      tooltip: {
                        headerFormat: '',
                        enabled: tooltipEnabled,
                        useHTML:true,
                        name:false,
                        backgroundColor: '#2B2B30',
                        borderWidth: 0,
                        borderRadius:20,
                        pointFormat:'<div>'+
                            '<div style="background: #2B2B30; box-shadow: 0px 4px 48px rgba(43, 43, 48, 0.08); border-radius: 8px; display: inline-flex; flex-wrap: wrap; width: 309px;"><div style="padding: 12px 19px 8px; border-bottom: 2px solid rgba(255, 255, 255, 0.1); width: 100%;">'+
                            '<span style="color: white; font-size: 14px; line-height: 16px; white-space: pre-wrap; word-break: break-word;">'+finalPollsViews[polls_action_index].poll_title+'</span>'+
                            '</div>'+
                            '<div style="padding: 14px 19px 32px; display: flex; width: 100%; position: relative;">'+
                            '<div style="margin-right: 30px; display: inline-flex; flex-wrap: wrap;"><span style="color: white; width: 100%;font-size: 21px;">'+totalAttenddes+'</span><span style="color: white; font-weight: 400; font-size: 14px;">'+attendeesCaption+'</span></div>'+
                            '<div style="margin-right: 30px; display: inline-flex; flex-wrap: wrap;"><span style="color: white; width: 100%;font-size: 21px;">'+finalPollsViews[polls_action_index].views+'</span><span style="color: white; font-weight: 400; font-size: 14px;">'+viewsCaption+'</span></div>'+
                            '<div style="margin-right: 30px; display: inline-flex; flex-wrap: wrap;"><span style="color: white; width: 100%;font-size: 21px;">'+finalPollsViews[polls_action_index].clicks+'</span><span style="color: white; font-weight: 400; font-size: 14px;">'+responseCaption+'</span></div>'+
                            '<img style="position: absolute; bottom: 9px; right: 11px;" src="'+pollImage+'" alt="offers">'+
                            '</div></div></div>'

                      }
                    });
                    tooltipEnabled = !tooltipEnabled;
                  },
                  mouseOver: function () {
                    var chart = this.series.chart;
                    chart.update({
                      tooltip: {
                        enabled: false,
                      }
                    })

                  },
                  mouseOut: function () {
                  var chart = this.series.chart;
                  tooltipEnabled = true;
                  chart.update({
                    tooltip: {
                      enabled: false,
                    }
                  })
                }
                }
            };
          });

          attendeeMinsIndex.forEach((attendeeMinsIndex) => {
           // attendeeSericeData[attendeeMinsIndex]=this.roomActivityMapSeries[0];
            attendeeSericeData[attendeeMinsIndex]={               
               y: this.roomActivityMapSeries[0], //0.2
               tooltip: {
                enabled: true,
                pointFormat: 'Attendees  <b>{point.y:,.0f}',
              },
            events: {
              mouseOver: function () {
                var chart = this.series.chart;
                chart.update({
                  tooltip: {
                    enabled: true,
                    pointFormat: 'Attendees  <b>{point.y:,.0f}',
                    padding: 12,
                    distance: 16,
                    shared: true,
                    useHTML: true,
                    borderRadius: 8,
                    borderColor: "none",
                    followTouchMove: false,
                    backgroundColor: "#ffffff",
                   // formatter(e) {return 'Attend  <b>{point.y:,.0f}'},
                    shadow: {
                      color: "rgba(0,0,0,0.32)",
                      offsetX: 0,
                      offsetY: 1,
                      opacity: 0.32,
                      width: 3
                    },
                    style: {
                      color: "#000000",
                      fontSize: "12px",
                      lineHeight: "16px"
                    }
                  }
                })
              },
              mouseOut: function () {
                var chart = this.series.chart;
                chart.update({
                  tooltip: {                   
                    enabled: false,                   
                  }
                })
              }
            } 
        };
            this.roomActivityMapSeries.splice(0, 1);
          });
         

         if(this.roomActivityMapXaxias.length == 0){
          this.roomActivityMapXaxias = [0];
         }

         if(attendeeSericeData.length == 0){
          attendeeSericeData = [0];
         }
          let seriesOfferData={
              name: this.transLationMessages.WEBINAR_ANALYTICS.OFFER_SENT,
              className:"room-activity-offer-wrapper",
              data: offerSericeData,
             // enableMouseHover: false,
              type: 'scatter',
              marker: {
                symbol: this.offerIconForChartHeading,

              },
              tooltip: {
                enabled: false,
                stickyTracking: false,
              },

          };

          let seriesPollData={
              name: this.transLationMessages.WEBINAR_ANALYTICS.POLL_SENT,
              className:"room-activity-poll-wrapper",
              data: pollSericeData,
              type: 'scatter',
              marker: {
                symbol: this.pollIconForChartHeading,
              },
              tooltip: {
                enabled: false,
                stickyTracking: false,
              }
          };

          let seriesData={
              name: this.transLationMessages.WEBINAR_ANALYTICS.ATTENDEES,
              className:"room-activity-attendees-wrapper",
              data: attendeeSericeData,
              tooltip: {
                pointFormat: this.transLationMessages.WEBINAR_ANALYTICS.ATTENDEES+' <b>{point.y:,.0f}',
                enabled: true
              },
              //data: [2,4,5,4,5,4,5,4,5,4,5,4,5,4],
              color: '#81ccfd',
          };
          this.optionsRoomActivity["xAxis"]["categories"] = this.optionsRoomActivity["series"] = [];
          this.showSectionLoaderForRoomActivityChart=false;
         // console.log("room activity data",this.roomActivityMapXaxias);
          this.optionsRoomActivity["xAxis"]["categories"]=this.roomActivityMapXaxias;
          this.optionsRoomActivity["series"].push(seriesData);
          this.optionsRoomActivity["series"].push(seriesOfferData);
          this.optionsRoomActivity["series"].push(seriesPollData);
          this.updateGraph = true;
          
          try {
          console.log("llll",offerSericeData.length,offerSericeData);
            let emptyCount = 0;
            if(Array.isArray(attendeeSericeData) && attendeeSericeData[0] <= 0){
              emptyCount++;
            }
            if(Array.isArray(offerSericeData) && offerSericeData.length == 0){
              emptyCount++;
            }
            if(Array.isArray(pollSericeData) && pollSericeData.length == 0){
              emptyCount++;
            }
            if(emptyCount === 3){
              this.noRoomActivity = true;
            }else 
            this.noRoomActivity = false;
          } catch (error) {
            console.log("error in room activity chart empty check", error)
          }
  
          
          //console.log("room activity data",this.optionsRoomActivity);
          
        } else {  
        this.showSectionLoaderForRoomActivityChart=true;
        
          console.log('Error in api request*');
        }

      },
      (error) => {
       this.showSectionLoaderForRoomActivityChart=true;
        console.log('error', error);

      }
    );
  }



  getPollsForRoomActivity(){

    let pollModel={
      "query" : {
        "index" : "poll_tracking",
        "body": {
          "from" :0,
          "size": 1,
          "query" : {
            "bool" :{
              "must" : [
              ]
            }
          },
          "aggs" :{​​​
            "poll_activity": {​​​
              "terms": {​​​
                "field": "poll_desc.poll_question",
                "size" : 1000
              }​​​,
              "aggs" : {​​​
                "poll_displayed_after_minutes" :{​​​
                  "terms" :{​​​
                    "field" : "poll_displayed_after_minutes"
                  }​​​
                }​​​,
              }
              }​​​,
                "polls": {​​​
                  "terms": {​​​
                    "field": "poll_desc.poll_question"
                  }​​​,
                  "aggs" : {​​​
                    "views" :{​​​
                      "filter" : {​​​
                        "term" :{​​​
                          "poll_action" : 1
                        }​​​
                      }​​​
                    }​​​,
                    "clicks" : {​​​
                      "filter" : {​​​
                        "term" :{​​​
                        "poll_action" : 2
                        }​​​
                      }​​​
                    }​​​
                  }​​​
                }​​​
            ​​​
          }​​​,
        }
      }
    };

    let mainConditionsPoll={
      "match" : {
        "webinar_id" : this.event_id
      }
    };
    let mainConditionsPoll2={
      "match" : {
        "is_from_replay" : 0
      }
    };

    pollModel["query"]["body"]["query"]["bool"]["must"].push(mainConditionsPoll);
    pollModel["query"]["body"]["query"]["bool"]["must"].push(mainConditionsPoll2);

    //Automated Event
   /*if(this.isNotLiveEvent == true){
      let filterQuery={
        "match" : {
          "event_version_id" :this.selected_session
        }
      };
      pollModel["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
    }else{
      let filterQuery={
        "match" : {
         // "session_date": this.selected_session
         "session_id":this.selected_session_id
        }
      };
      pollModel["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
    }*/

    let filterQuery={
      "match" : {
       "session_id":this.selected_session_id
      }
    };
    pollModel["query"]["body"]["query"]["bool"]["must"].push(filterQuery);
    this.finalMinsArrayForPoll = [];
    this.tableListService.getAttendees(pollModel).subscribe(
      (response: any) => {



        if (response.statusCode == statusCodes.SUCCESS) { 
          let poll_activity = response.body.aggregations.poll_activity.buckets;
          let polls_views = response.body.aggregations.polls.buckets;

          let pollMinsArray=[];
          poll_activity.forEach( (element,index) => {
            pollMinsArray.push(element.poll_displayed_after_minutes.buckets);
          });

          polls_views.forEach( (element,index) => {
            let actions = {'poll_title':element.key,"views":element.views.doc_count,"clicks":element.clicks.doc_count};
            this.pollsViewArray.push(actions);
          });

          if(pollMinsArray.length){
            pollMinsArray.forEach( (element) => {
              this.finalMinsArrayForPoll.push(element[0].key);

              this.roomActivityMapVideoMins.push(element[0].key);
            });

          }


          this.getOfferForRoomActivity();

        } else { 
          this.showSectionLoaderForRoomActivityChart=true;
          console.log('Error in api request');
        }

      },
      (error) => {
        this.showSectionLoaderForRoomActivityChart=true;
        console.log('error', error);

      }
    );
  }
  /**
   *
   * @param value
   */
  onSessionChange(value:string){ 

 // if(this.isNotLiveEvent == false){
     this.sessions.forEach( (element,index) => {
      if(element.session_date_time == value){
        this.selected_session_id = element.session_id;
      }
    });
 // }
      this.selected_session=value;
      this.getRoomActivityData();

  }

  /**
   * Session Video Listing API
   */
  getSessionList() {

    const model = {
      "event_id":this.event_id,
      "startDate":this.startDate,
      "endDate":this.endDate
    };
    this.tableListService.getSessionList(model).subscribe(
      (response: any) => { 
        if (response.status.code == statusCodes.SUCCESS) {
          this.sessions= response.data;
          if(this.sessions){
            this.selected_session=this.sessions[0].session_date_time;
            this.selected_session_id=this.sessions[0].session_id;
            this.getRoomActivityData();
          }

        } else {
          this.showSectionLoaderForRoomActivityChart=false;
          this.noRoomActivity=true;
          let seriesData={
            name: this.transLationMessages.WEBINAR_ANALYTICS.ATTENDEES,
            data: [0],
            color: '#81ccfd',
        };
        this.optionsRoomActivity["xAxis"]["categories"]=this.roomActivityMapXaxias;
        this.optionsRoomActivity["series"].push(seriesData);
          console.log('Error in api request');
        }

      },
      (error) => {
        this.showSectionLoaderForRoomActivityChart=false;
        console.log('error', error);

      }
    );
  }

  getSessionVideoList() {
    const model = {
      "event_id":this.event_id,
    };
    this.tableListService.getSessionVideoList(model).subscribe(
      (response: any) => { 
        if (response.status.code == statusCodes.SUCCESS) {
          this.sessionsVideo= response.data;

          if(this.sessionsVideo){
            this.selected_session=this.sessionsVideo[0].event_version_id;
            this.getRoomActivityData();
          }

        } else {
         // this.getRoomActivityData();
          this.showSectionLoaderForRoomActivityChart=false;
          console.log('Error in api request!!!!');
        }

      },
      (error) => {
        this.showSectionLoaderForRoomActivityChart=false;
        console.log('error', error);

      }
    );
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  decodeHtmlData(text:string){
    let txt = document.createElement("textarea");
        txt.innerHTML = text.replace(/\\/g,'').replace(/&amp;/g, '&');
        return txt.value;

  }

  pageChanged(page: number) {
    this.page = page;
    this.offset = (this.page -1) * this.limit;

    if(this.offset == 1){
      this.offset=0;
    }
    this.getChatHistory();
  }

  pageChangedRegister(page: number) {
    this.registerPage = page;
    this.registerOffest = (this.registerPage -1) * this.limit;
    if(this.registerOffest == 1){
      this.registerOffest=0;
    }
    //this.getWebinarStats();
if(this.searchAttendee.value != ''){
  this.searchAttendees();
}else{ 
   this.showRegistLoader = true;
   this.model={
     "query" : {
       "index" : "attendees",
       "body": {
         "from" :this.registerOffest,
         "size": this.limit,
         "query" : {
           "bool" :{
             "must" : [
               {
               "match" : {
                 "webinar_id" :this.event_id
               }
             },
             {
               "range": {
                 "session_date": {
                   "gte":this.startDate+' 00:00:00',
                   "lte":this.endDate+' 23:59:59',
                   // "format": "YYYY-MM-DD"
                 }
               }
             }
           ,{
             "query_string": {
               "query": "**",
               "fields": [ "attendee_name", "attendee_email" ],
             }
           }
             ]
           }
         },
         "sort" : {
           "signup" :{
             "order" : "desc"
           }
         },
         "aggs": {
           "registrants": {
             "filter" : {
             "term" :{
               "webinar_id" :this.event_id
             }
             },
             "aggs" : {
               "attendees" :{
                 "filter" : {
                   "term" :{
                   "event_activity" : 1
                   }
                 }
               },
               "replay_attendees" :{
                 "filter" : {
                 "term" :{
                 "replay_activity" : 1
                 }
                 }
               }
             }
           }
         }
       }
     }
   };
   this.showSectionLoader = true;
   this.tableListService.getAttendees(this.model).subscribe(
     (response: any) => {
       this.showSectionLoader = false;
       this.showRegistLoader = false;
       if (response.statusCode == statusCodes.SUCCESS) {
         this.data = response.body.hits;
         this.registerCount = response.body.aggregations.registrants.doc_count;
       } else {
         console.log('Error in api request');
         this.showSectionLoader = false;
       }

     },
     (error) => {
       this.showSectionLoader = false;
       console.log('error', error);

     }
   );
  }
}

  onDateChange (event) { 
    this.startDate = moment(event.value.begin).format('YYYY-MM-DD');
    this.endDate = moment(event.value.end).format('YYYY-MM-DD');
    sessionStorage.setItem('startDate_'+this.event_id, this.startDate);
    sessionStorage.setItem('endDate_'+this.event_id, this.endDate);
    this.getWebinarStats();
    this.getCTAStats();
    this.getChatHistory();
    this.getVisitorChartData();
  }

  onScroll(){

    this.showChatlistLoader = true;
    let totalRecords = this.isNotLiveEvent ===  false ? this.chats.length:this.questions.length;
    if(this.totalItemsChat>totalRecords){
      this.chatOffset = this.chatOffset+this.chatLimit;
      this.getChatHistory();

    }else{
      this.showChatlistLoader = false;
    }
  }

  V2CDN():any  {
    return this.tableListService.getV2CDN();
  }

  checkEmojis(chatMsg){

    var mapObj = {
      ':thumbsup:': '<img src="'+this.emojiURL+'thumbsup.png" alt="thumbsup" class="emoji-chat" />',
      ':stuck_out_tongue_winking_eye:': '<img src="'+this.emojiURL+'stuck_out_tongue_winking_eye.png" alt="stuck_out_tongue_winking_eye" class="emoji-chat" />',
      ':wink:': '<img src="'+this.emojiURL+'wink.png" alt="wink" class="emoji-chat" />',
      ':laughing:': '<img src="'+this.emojiURL+'laughing.png" alt="wink" class="emoji-chat" />' ,
      ':smile:': '<img src="'+this.emojiURL+'smile.png" alt="smile" class="emoji-chat" />', 
      ':blush:': '<img src="'+this.emojiURL+'blush.png" alt="blush" class="emoji-chat" />', 
      ':smiley:': '<img src="'+this.emojiURL+'smiley.png" alt="smiley" class="emoji-chat" />', 
      ':clap:': '<img src="'+this.emojiURL+'clap.png" alt="clap" class="emoji-chat" />', 
      ':v:': '<img src="'+this.emojiURL+'v.png" alt="v" class="emoji-chat" />', 
      ':two_hearts:': '<img src="'+this.emojiURL+'two_hearts.png" alt="two_hearts" class="emoji-chat" />', 
      ':astonished:': '<img src="'+this.emojiURL+'astonished.png" alt="astonished" class="emoji-chat" />', 
      ':anguished:': '<img src="'+this.emojiURL+'anguished.png" alt="anguished" class="emoji-chat" />', 
      ':bowtie:': '<img src="'+this.emojiURL+'bowtie.png" alt="bowtie" class="emoji-chat" />', 
      ':confused:': '<img src="'+this.emojiURL+'confused.png" alt="confused" class="emoji-chat" />', 
      ':hand:': '<img src="'+this.emojiURL+'hand.png" alt="hand" class="emoji-chat" />', 
      ':heartpulse:': '<img src="'+this.emojiURL+'heartpulse.png" alt="heartpulse" class="emoji-chat" />', 
      ':heartbeat:': '<img src="'+this.emojiURL+'heartbeat.png" alt="heartbeat" class="emoji-chat" />', 
      ':heart:': '<img src="'+this.emojiURL+'heart.png" alt="heart" class="emoji-chat" />', 
      ':ok_hand:': '<img src="'+this.emojiURL+'ok_hand.png" alt="ok_hand" class="emoji-chat" />', 
      ':weary:': '<img src="'+this.emojiURL+'weary.png" alt="weary" class="emoji-chat" />', 
      ':worried:': '<img src="'+this.emojiURL+'worried.png" alt="worried" class="emoji-chat" />', 
      ':stuck_out_tongue:': '<img src="'+this.emojiURL+'stuck_out_tongue.png" alt="stuck_out_tongue" class="emoji-chat" />', 
      ':stuck_out_tongue_closed_eyes:': '<img src="'+this.emojiURL+'stuck_out_tongue_closed_eyes.png" alt="stuck_out_tonguestuck_out_tongue_closed_eyes" class="emoji-chat" />', 
      ':sunglasses:': '<img src="'+this.emojiURL+'sunglasses.png" alt="sunglasses" class="emoji-chat" />', 
    };

    var re = new RegExp(Object.keys(mapObj).join("|"), "gi");

    chatMsg = chatMsg.replace(re, function (matched) {
      return mapObj[matched.toLowerCase()];
    });
    return chatMsg;
  }

  sortData(sort: Sort) {
    if(!sort.active) return

    if(!sort.direction){
      (event as any).target.click();
    }
    let columnName=sort.active;

    //Create SORT KEY first then put value
    this.model["query"]["body"]["sort"]={};

    this.model["query"]["body"]["sort"][columnName]={
      "order" : sort.direction
    };

    this.tableListService.getAttendees(this.model).subscribe(
      (response: any) => {
        this.showSectionLoader = false;
        this.showRegistLoader = false;
        if (response.statusCode == statusCodes.SUCCESS) {
          this.data = response.body.hits;
          this.registerCount = response.body.aggregations.registrants.doc_count;
          this.attendeeCount = response.body.aggregations.registrants.attendees.doc_count;
          this.watchedReplayCount = response.body.aggregations.registrants.replay_attendees.doc_count;
        } else {
          console.log('Error in api request');
          this.showSectionLoader = false;
        }

      },
      (error) => {
        this.showSectionLoader = false;
        console.log('error', error);

      }
    );

  }
}